import RoutesMap from "../../route_control/RouteControl"
import {
    VendorList,
    AddVendor,
    UpdateVendor,
} from "../../pages/purchase"

export const PurchaseImport = {
    RoutesMap,
    VendorList,
    AddVendor,
    UpdateVendor,
}